import React, { useContext, createContext, useState } from 'react'

import { useFirebase } from '../firebaseContext'

const authContext = createContext()

export function ProvideAuth({ children }) {
  const auth = useProvideAuth()
  return (
    <authContext.Provider value={auth}>
      {children}
    </authContext.Provider>
  )
}

export function useAuth() {
  return useContext(authContext)
}

function useProvideAuth() {
  const [user, setUser] = useState(null)
  const firebase = useFirebase()

  const signin = (form, loginSuccess, loginError) => {
    firebase.loginWithEmail(form.email, form.password)
    .then(async ({ user }) => {
      const { uid } = user
      const sn = await firebase.getDocRef('users', uid).get()
      const u = sn.data()
      if(u.role === 'admin'){
        setUser(uid)
        loginSuccess()
      } else {
        loginError({ message: 'No estás autorizado para acceder.' })
      }
    })
    .catch(error => {
      loginError(error)
    })
  }

  const autoin = cb => {
    firebase.auth().onAuthStateChanged(async usr => {
      if(usr){
        const { uid } = usr
        const sn = await firebase.getDocRef('users', uid).get()
        const u = sn.data()
        if(u.role === 'admin'){
          setUser(uid)
        }
      }
      cb()
    })
  }

  const signout = cb => {
    firebase.signOut()
    .then(() => {
      setUser(null)
      cb()
    })
  }

  return {
    user,
    signin,
    autoin,
    signout
  }
}